module.exports = "<h2>Quotazione cellulari usati: {{phone.brand.name}} - {{phone.name}}</h2>\n  <app-variant-list [variants]=\"variants\"></app-variant-list>\n\n<h3>Cellulari Suggeriti per te</h3>\n<app-variant-list *ngIf=\"suggestedVariants\"  [variants]=\"suggestedVariants\"></app-variant-list>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/phone-list/phone-list.component.html
// module id = 747
// module chunks = 1